var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.loading)?_c('main-loader'):_c('data-tree-table',{attrs:{"data-tree":_vm.dataTree,"data-tree-result":_vm.dataTreeResult,"headers":_vm.headers,"disable-zoom":_vm.disableZoom}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }